import { createQuery, createSuspenseQuery } from 'react-query-kit';

import { type NewMapBannerContent } from '@/api/zepetoful.api/model';
import { type PromotionNewMapDataType } from '@/module/play/modal';

import { getCmsContent } from './client';
import { CMS_CONTENT_IDS } from './constants';

const DEFAULT_NEW_MAP_BANNER = {
  ko: [],
  en: [],
  ja: [],
};

/**
 * NewMapBanner 콘텐츠 조회 훅
 * 사용처: NewMapBanner.tsx
 */
export const useCmsNewMapBannerContent = createQuery<
  NewMapBannerContent,
  { contentId: string }
>({
  queryKey: ['cms', 'new-map-banner-content'],
  fetcher: async variables => {
    try {
      return await getCmsContent<NewMapBannerContent>(variables);
    } catch {
      return DEFAULT_NEW_MAP_BANNER;
    }
  },
  variables: {
    contentId: CMS_CONTENT_IDS.NEW_MAP_BANNER,
  },
});

/**
 * NewMapModal 콘텐츠 조회 훅 (Suspense 버전)
 * 사용처: PromotionNewMapModal.tsx
 */
export const useCmsNewMapSuspenseQuery = createSuspenseQuery<
  PromotionNewMapDataType,
  { contentId: string }
>({
  queryKey: ['cms', CMS_CONTENT_IDS.NEW_MAP_MODAL],
  fetcher: getCmsContent,
  variables: {
    contentId: CMS_CONTENT_IDS.NEW_MAP_MODAL,
  },
});
